<script setup>
/* eslint-disable no-unused-vars */
import SelectFileType from "@/pages/CreateConnection/SelectFileType.vue";
import { computed, ref, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import FilesProcessor from "@/components/Connection/FilesProcessor.vue";
import FileProcessor from "@/components/Connection/FileProcessor.vue";
import {Api} from "@/service/api";
import SelectDataProcessorType from "@/pages/CreateConnection/SelectDataProcessorType.vue";
import FilterProcessor from "@/components/Connection/FilterProcessor.vue";
import {createToaster} from "@meforma/vue-toaster";
import YandexDirectStatProcessor from "@/components/YandexDirectStatistics/YandexDirectStatProcessor.vue";
import ConnectionStage from "@/pages/CreateConnection/ConnectionStage.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import VKAdsStatProcessor from "@/components/VKAdwordsStatistics/VKAdsStatProcessor.vue";
import { useYandexStatistics } from "@/pages/CreateConnection/composables/useYandexStatistics"
import {useGoogleSheets} from "@/pages/CreateConnection/composables/useGoogleSheets";
import {useConnectionCreate} from "@/pages/CreateConnection/composables/useConnectionCreate";
import {useStages} from "@/pages/CreateConnection/composables/useStages";
import {useVKCampaign} from "@/pages/CreateConnection/composables/useVKCampaign";
import BitrixUpload from "@/components/CreateConnectionComponents/BitrixUpload/IndexView.vue"
import BitrixFilterProcessor from "@/components/CreateConnectionComponents/BitrixUpload/components/BitrixFilterProcessor.vue"
import {useBitrixUpload} from "@/pages/CreateConnection/composables/useBitrixUpload";


const sourceType = ref("")
const targetType = ref("")

const isAccountAttached = ref(true)


const router = useRouter()
const route = useRoute()
const toaster = createToaster({});

const { selectedYandexAccount, yandexUpload, isYandexDataInputRight } = useYandexStatistics()
const { selectedVKAccount, vkAdsUpload, isVKDataInputRight } = useVKCampaign()
const { connection, reloadTabsSource, reloadTabsTarget, saveFilesSource, saveFilesTarget } = useGoogleSheets()
const { bitrixAccount, bitrixUpload, isBitrixDataInputRight } = useBitrixUpload()
const { isCreateButtonActive, isLoadingCreating, createConnection } = useConnectionCreate(
    connection,
    yandexUpload,
    selectedYandexAccount,
    vkAdsUpload,
    selectedVKAccount,
    bitrixUpload,
    bitrixAccount,
    sourceType,
    isYandexDataInputRight,
    isVKDataInputRight,
    isBitrixDataInputRight,
    toaster,
    route,
    router
)
const { createStages, currentStage } = useStages()

const isSourceTypeSelected = ref(false)
const isDataProcessorSelected = ref(false)
const isTargetTypeSelected = ref(false)
const isSourceToggle = ref(false)
const isFilterToggle = ref(false)

const isFilterSkipped = ref(false)


const isSourceModalVisible = ref(false);
const isTargetModalVisible = ref(false)

const selectedProcessorType = ref({})


const isManyTables = computed(() => {
    return connection.value.files_source.length > 1;
})

const bitrixDataTypeLabels = {
    LEADS: 'Лиды',
    DEALS: 'Сделки',
    CONTACTS: 'Контакты',
}

const bitrixDataTypeLabel = computed(() => {
    return bitrixDataTypeLabels[bitrixUpload.value?.dataType] || ''
})


onBeforeMount(async () => {
    try {
        await Api.getUserGoogleAccessToken()
    }
    catch (e) {
        if (e.response.status === 403) {
            isAccountAttached.value = false
        }
    }
})

function selectType(processorType) {
    if (processorType === "SOURCE") {
        isSourceTypeSelected.value = true
    }
    if (processorType === "DESTINATION") {
        isTargetTypeSelected.value = true
    }
}

function openModal() {
    isSourceModalVisible.value = true
}

function openModalTarget() {
    isTargetModalVisible.value = true
}

function addSource() {
    connection.value.files_source.push({tabs: [], tab: {}})
}

function changeStep() {
    isSourceTypeSelected.value = false
    createStages.value[1].isSkipped = false
    connection.value.files_source = [
        {
            tabs: [],
            tab: {},
        }
    ]
}

function changeStepTarget() {
    isTargetTypeSelected.value = false
    connection.value.file_target = {tabs: [], tab: {}}
}

function selectProcessorType(value) {
    selectedProcessorType.value = value
    isDataProcessorSelected.value = true
}

function changeDataProcessorStep() {
    connection.value.filter = {
        conditions: [],
        conditionType: 'AND'
    }
    isDataProcessorSelected.value = false
}

function openNextStep(stage, skipFilter = false) {
    isSourceToggle.value = true

    currentStage.value = stage
    currentStage.value.isFocused = true

    if (skipFilter === true) {
        createStages.value[1].isSkipped = true
    }
}

function skipDataProcessor() {
    openNextStep(createStages.value[2])
    isFilterSkipped.value = true
}


</script>

<template>
    <div class="w-full h-screen flex">
        <NavigationBar />
        <div class="w-full h-full flex flex-col">
            <div class="w-full h-full overflow-y-auto bg-[#DEEAF7]">
                <div class="flex w-full flex-col h-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12">
                    <div class="sticky top-0 z-10 bg-[#DEEAF7] w-full">
                        <ConnectionStage
                            class="my-4"
                            v-model:stages="createStages"
                            v-model:stage="currentStage"
                        />
                    </div>
                    <div class="w-full h-full" v-show="currentStage.stage === 'SOURCE'">
                        <SelectFileType
                            v-if="!isSourceTypeSelected"
                            v-model="sourceType"
                            class="w-full"
                            @select-type="selectType('SOURCE')"
                            fileType="SOURCE"
                        />
                        <div class="w-full" v-else>
                            <FilesProcessor
                                v-if="sourceType === 'GOOGLE_SHEETS'"
                                class="w-full"
                                processor-type="SOURCE"
                                v-model:files="connection.files_source"
                                v-model:is-toggle="isSourceToggle"
                                v-model:isAccountAttached="isAccountAttached"
                                @reload-tabs="reloadTabsSource"
                                @open-modal="openModal"
                                @add-source="addSource"
                                @change-step="changeStep"
                                @next-step="openNextStep(createStages[1])"
                                @save-files="saveFilesSource"
                            />
                            <YandexDirectStatProcessor
                                v-if="sourceType === 'YANDEX_DIRECT_STAT'"
                                v-model:account="selectedYandexAccount"
                                v-model:startDate="yandexUpload.startDate"
                                v-model:endDate="yandexUpload.endDate"
                                @next-step="openNextStep(createStages[2], true)"
                                @change-step="changeStep"
                            />
                            <VKAdsStatProcessor
                                v-if="sourceType === 'VKONTAKTE_CAMPAIGN_STAT'"
                                v-model:account="selectedVKAccount"
                                v-model:startDate="vkAdsUpload.startDate"
                                v-model:endDate="vkAdsUpload.endDate"
                                @next-step="openNextStep(createStages[2], true)"
                                @change-step="changeStep"
                            />
                            <BitrixUpload
                                v-model:account="bitrixAccount"
                                v-model:dataType="bitrixUpload.dataType"
                                v-if="sourceType === 'BITRIX_UPLOAD'"
                                @change-step="changeStep"
                                @next-step="openNextStep(createStages[1])"
                            />
                        </div>
                        <div class="h-10 w-full"></div>
                    </div>
                    <div
                        class="flex flex-col items-center w-full"

                        v-show="currentStage.index === 2"
                        v-if="sourceType !== 'YANDEX_DIRECT_STAT'"
                    >
                        <BitrixFilterProcessor
                            v-if="sourceType === 'BITRIX_UPLOAD'"
                            class="w-full"
                            v-model="isFilterToggle"
                            :data-type="bitrixUpload.dataType"
                            :data-type-label="bitrixDataTypeLabel"
                            :account="bitrixAccount"
                            v-model:directions="bitrixUpload.filter.directions"
                            v-model:stages="bitrixUpload.filter.stages"
                            v-model:condition-type="bitrixUpload.filter.conditionType"
                            v-model:conditions="bitrixUpload.filter.conditions"
                            v-model:date-field="bitrixUpload.filter.dateField"
                            v-model:start-date="bitrixUpload.filter.startDate"
                            v-model:end-date="bitrixUpload.filter.endDate"
                            @change-step="changeDataProcessorStep"
                            @next-step="openNextStep(createStages[2])"
                        />
                        <template v-else>
                            <SelectDataProcessorType
                                class="w-full"
                                v-if="!isDataProcessorSelected"
                                v-model:selected-data-processor-type="selectedProcessorType"
                                @select-filter="selectProcessorType"
                                @skip-step="skipDataProcessor"
                            />
                            <FilterProcessor
                                v-else
                                class="w-full"
                                v-model:conditions="connection.filter.conditions"
                                v-model:condition-type="connection.filter.conditionType"
                                v-model:spreadsheet-id="connection.files_source[0].id"
                                v-model:tab-id="connection.files_source[0].tab.sheetId"
                                :is-many-tables="isManyTables"
                                :isToggle="isFilterToggle"
                                @change-step="changeDataProcessorStep"
                                @next-step="openNextStep(createStages[2])"
                            />
                        </template>
                    </div>
                    <div
                        class="w-full flex flex-col items-center"
                        v-show="currentStage.index === 3"

                    >
                        <SelectFileType
                            v-if="!isTargetTypeSelected"
                            v-model="targetType"
                            class="w-full"
                            @select-type="selectType('DESTINATION')"
                            fileType="TARGET"
                        />
                        <FileProcessor
                            v-else
                            class="w-full"
                            processor-type="DESTINATION"
                            v-model:file="connection.file_target"
                            @reload-tabs="reloadTabsTarget"
                            @open-modal="openModalTarget"
                            @next-step="createConnection"
                            :isCreateButtonActive="isCreateButtonActive"
                            :is-loading="isLoadingCreating"
                            @save-files="saveFilesTarget"
                            @change-step="changeStepTarget"
                            v-model:isAccountAttached="isAccountAttached"

                        />
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>